
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FreeAssessmentPage = lazy(() => import('../pages/free-assessment/page'));
const BookCallPage = lazy(() => import('../pages/book-call/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Blog Articles
const AIOutboundAutomationGuide = lazy(() => import('../pages/blog/articles/ai-outbound-automation-guide/page'));
const SalesProcessOptimization = lazy(() => import('../pages/blog/articles/sales-process-optimization/page'));
const AuthorityBuildingContent = lazy(() => import('../pages/blog/articles/authority-building-content/page'));
const RevenueOperationsFramework = lazy(() => import('../pages/blog/articles/revenue-operations-framework/page'));
const FounderLedSalesTransition = lazy(() => import('../pages/blog/articles/founder-led-sales-transition/page'));
const AIToolsServiceBusinesses = lazy(() => import('../pages/blog/articles/ai-tools-service-businesses/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/ai-outbound-automation-guide',
    element: <AIOutboundAutomationGuide />
  },
  {
    path: '/blog/sales-process-optimization',
    element: <SalesProcessOptimization />
  },
  {
    path: '/blog/authority-building-content',
    element: <AuthorityBuildingContent />
  },
  {
    path: '/blog/revenue-operations-framework',
    element: <RevenueOperationsFramework />
  },
  {
    path: '/blog/founder-led-sales-transition',
    element: <FounderLedSalesTransition />
  },
  {
    path: '/blog/ai-tools-service-businesses',
    element: <AIToolsServiceBusinesses />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/free-assessment',
    element: <FreeAssessmentPage />
  },
  {
    path: '/book-call',
    element: <BookCallPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
